const ErrorIcon = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.99951" cy="10" r="6.75146" stroke="currentColor" strokeWidth="1.5" />
    <rect x="9.25" y="5.84863" width="1.50103" height="5.64706" fill="currentColor" />
    <rect x="9.25" y="12.6506" width="1.50064" height="1.50064" fill="currentColor" />
  </svg>
);

export default ErrorIcon;
